import store from '../store/store'
import Filtro from '../views/shared/listFiltroClientes.vue';
import FiltroClientes from '../views/shared/listFiltroClientes.vue';

export function getVistaPresupuestoInterno(presupuesto) {
    let datos = [];
    switch (store.getters['user/rolId']) {
        case 1: /* Superadministrador */
        case 2: /* Direccion */
        case 6: /* Director Administrativo */
        case 7: /* Asist. Administracion */
        case 8: /* Calidad */
        case 9: /* Director Ejecutivo */
        case 21: /* Responsable de Finanzas y Proveedores */
        case 22: /* Responsable de Facturacion e Impuestos */
        case 23: /* Asistente de Calidad */
            if (presupuesto.discriminarFeePremios) {
                datos = [
                    { 'nombre': 'id', 'campo': 'Nro.', 'valor': presupuesto.id, 'formato': '' },
                    { 'nombre': 'prioridad', 'campo': 'Prioridad', 'valor': presupuesto.prioridad, 'formato': '' },
                    { 'nombre': 'fechaEntrega', 'campo': 'Fecha Entrega', 'valor': presupuesto.fechaEntrega, 'formato': 'fecha' },
                    { 'nombre': 'cliente', 'campo': 'Cliente', 'valor': presupuesto.cliente, 'formato': '' },
                    { 'nombre': 'accion', 'campo': 'Acción', 'valor': presupuesto.accion, 'formato': '' },
                    { 'nombre': 'clienteContacto', 'campo': 'Contacto', 'valor': presupuesto.clienteContacto, 'formato': '' },
                    { 'nombre': 'numeroOrdenCompra', 'campo': 'Nro. Orden de Compra', 'valor': presupuesto.numeroOrdenCompra, 'formato': '' },
                    { 'nombre': 'descripcionOrdenCompra', 'campo': 'Descripción de la Orden de Compra', 'valor': presupuesto.descripcionOrdenCompra, 'formato': '' },
                    { 'nombre': 'feeAgencia', 'campo': 'Fee de Agencia', 'valor': presupuesto.feeAgencia, 'formato': 'porcentaje' },
                    { 'nombre': 'feeAgenciaPremios', 'campo': 'Fee de Rubros Diferenciados', 'valor': presupuesto.feeAgenciaPremios, 'formato': 'porcentaje' },
                    { 'nombre': 'discriminarFee', 'campo': 'Discriminar Fee', 'valor': presupuesto.discriminarFee? 'Si' : 'No', 'formato': '' },
                    { 'nombre': 'causaSocial', 'campo': 'Causa Social', 'valor': presupuesto.causaSocial? 'Si' : 'No', 'formato': '' },
                    { 'nombre': 'causaAmbiental', 'campo': 'Causa Ambiental', 'valor': presupuesto.causaAmbiental? 'Si' : 'No', 'formato': '' },
                ];
            } else {
                datos = [
                    { 'nombre': 'id', 'campo': 'Nro.', 'valor': presupuesto.id, 'formato': '' },
                    { 'nombre': 'prioridad', 'campo': 'Prioridad', 'valor': presupuesto.prioridad, 'formato': '' },
                    { 'nombre': 'fechaEntrega', 'campo': 'Fecha Entrega', 'valor': presupuesto.fechaEntrega, 'formato': 'fecha' },
                    { 'nombre': 'cliente', 'campo': 'Cliente', 'valor': presupuesto.cliente, 'formato': '' },
                    { 'nombre': 'accion', 'campo': 'Acción', 'valor': presupuesto.accion, 'formato': '' },
                    { 'nombre': 'clienteContacto', 'campo': 'Contacto', 'valor': presupuesto.clienteContacto, 'formato': '' },
                    { 'nombre': 'numeroOrdenCompra', 'campo': 'Nro. Orden de Compra', 'valor': presupuesto.numeroOrdenCompra, 'formato': '' },
                    { 'nombre': 'descripcionOrdenCompra', 'campo': 'Descripción de la Orden de Compra', 'valor': presupuesto.descripcionOrdenCompra, 'formato': '' },
                    { 'nombre': 'feeAgencia', 'campo': 'Fee de Agencia', 'valor': presupuesto.feeAgencia, 'formato': 'porcentaje' },
                    { 'nombre': 'discriminarFee', 'campo': 'Discriminar Fee', 'valor': presupuesto.discriminarFee? 'Si' : 'No', 'formato': '' },
                    { 'nombre': 'causaSocial', 'campo': 'Causa Social', 'valor': presupuesto.causaSocial? 'Si' : 'No', 'formato': '' },
                    { 'nombre': 'causaAmbiental', 'campo': 'Causa Ambiental', 'valor': presupuesto.causaAmbiental? 'Si' : 'No', 'formato': '' },
                ];
            }
            break;

        case 3: /* Cuentas */
        case 12: /* Asistente de promociones */
        case 13: /* Asistente de cuentas */
        case 15: /* Coordinador/a de promociones */
        case 16: /* Ejecutivo comercial */
        case 17: /* Asistente comercial */
        case 19: /* Coordinador/a comercial */
        case 20: /* Gerente comercial */
            if (presupuesto.discriminarFeePremios) {
                datos = [
                    { 'nombre': 'id', 'campo': 'Nro.', 'valor': presupuesto.id, 'formato': '' },
                    { 'nombre': 'cliente', 'campo': 'Cliente', 'valor': presupuesto.cliente, 'formato': '' },
                    { 'nombre': 'clienteRazonSocial', 'campo': 'Razón Social', 'valor': presupuesto.clienteRazonSocial, 'formato': '' },
                    { 'nombre': 'clienteCondicionFiscal', 'campo': 'Cond. Fiscal', 'valor': presupuesto.clienteCondicionFiscal, 'formato': '' },
                    { 'nombre': 'clienteCuit', 'campo': 'CUIT', 'valor': presupuesto.clienteCuit, 'formato': 'cuit' },
                    { 'nombre': 'clienteDireccion', 'campo': 'Dirección', 'valor': presupuesto.clienteDireccion, 'formato': '' },
                    { 'nombre': 'clienteLocalidad', 'campo': 'Localidad', 'valor': presupuesto.clienteLocalidad, 'formato': '' },
                    { 'nombre': 'accion', 'campo': 'Acción', 'valor': presupuesto.accion, 'formato': '' },
                    { 'nombre': 'clienteContacto', 'campo': 'Contacto', 'valor': presupuesto.clienteContacto, 'formato': '' },
                    { 'nombre': 'numeroOrdenCompra', 'campo': 'Nro. Orden de Compra', 'valor': presupuesto.numeroOrdenCompra, 'formato': '' },
                    { 'nombre': 'descripcionOrdenCompra', 'campo': 'Descripción de la Orden de Compra', 'valor': presupuesto.descripcionOrdenCompra, 'formato': '' },
                    { 'nombre': 'feeAgencia', 'campo': 'Fee de Agencia', 'valor': presupuesto.feeAgencia, 'formato': 'porcentaje' },
                    { 'nombre': 'feeAgenciaPremios', 'campo': 'Fee de Rubros Diferenciados', 'valor': presupuesto.feeAgenciaPremios, 'formato': 'porcentaje' },
                    { 'nombre': 'discriminarFee', 'campo': 'Discriminar Fee', 'valor': presupuesto.discriminarFee? 'Si' : 'No', 'formato': '' },
                    { 'nombre': 'causaSocial', 'campo': 'Causa Social', 'valor': presupuesto.causaSocial? 'Si' : 'No', 'formato': '' },
                    { 'nombre': 'causaAmbiental', 'campo': 'Causa Ambiental', 'valor': presupuesto.causaAmbiental? 'Si' : 'No', 'formato': '' },
                ];
            } else {
                datos = [
                    { 'nombre': 'id', 'campo': 'Nro.', 'valor': presupuesto.id, 'formato': '' },
                    { 'nombre': 'cliente', 'campo': 'Cliente', 'valor': presupuesto.cliente, 'formato': '' },
                    { 'nombre': 'clienteRazonSocial', 'campo': 'Razón Social', 'valor': presupuesto.clienteRazonSocial, 'formato': '' },
                    { 'nombre': 'clienteCondicionFiscal', 'campo': 'Cond. Fiscal', 'valor': presupuesto.clienteCondicionFiscal, 'formato': '' },
                    { 'nombre': 'clienteCuit', 'campo': 'CUIT', 'valor': presupuesto.clienteCuit, 'formato': 'cuit' },
                    { 'nombre': 'clienteDireccion', 'campo': 'Dirección', 'valor': presupuesto.clienteDireccion, 'formato': '' },
                    { 'nombre': 'clienteLocalidad', 'campo': 'Localidad', 'valor': presupuesto.clienteLocalidad, 'formato': '' },
                    { 'nombre': 'accion', 'campo': 'Acción', 'valor': presupuesto.accion, 'formato': '' },
                    { 'nombre': 'clienteContacto', 'campo': 'Contacto', 'valor': presupuesto.clienteContacto, 'formato': '' },
                    { 'nombre': 'numeroOrdenCompra', 'campo': 'Nro. Orden de Compra', 'valor': presupuesto.numeroOrdenCompra, 'formato': '' },
                    { 'nombre': 'descripcionOrdenCompra', 'campo': 'Descripción de la Orden de Compra', 'valor': presupuesto.descripcionOrdenCompra, 'formato': '' },
                    { 'nombre': 'feeAgencia', 'campo': 'Fee de Agencia', 'valor': presupuesto.feeAgencia, 'formato': 'porcentaje' },
                    { 'nombre': 'feeAgenciaPremios', 'campo': 'Fee de Rubros Diferenciados', 'valor': presupuesto.feeAgenciaPremios, 'formato': 'porcentaje' },
                    { 'nombre': 'discriminarFee', 'campo': 'Discriminar Fee', 'valor': presupuesto.discriminarFee? 'Si' : 'No', 'formato': '' },
                    { 'nombre': 'causaSocial', 'campo': 'Causa Social', 'valor': presupuesto.causaSocial? 'Si' : 'No', 'formato': '' },
                    { 'nombre': 'causaAmbiental', 'campo': 'Causa Ambiental', 'valor': presupuesto.causaAmbiental? 'Si' : 'No', 'formato': '' },
                ];
            }
            break;
            
        default:
            datos = [
                { 'nombre': 'id', 'campo': 'Nro.', 'valor': presupuesto.id, 'formato': '' },
                { 'nombre': 'cliente', 'campo': 'Cliente', 'valor': presupuesto.cliente, 'formato': '' },
                { 'nombre': 'accion', 'campo': 'Acción', 'valor': presupuesto.accion, 'formato': '' },
                { 'nombre': 'clienteContacto', 'campo': 'Contacto', 'valor': presupuesto.clienteContacto, 'formato': '' },
            ];
            break;
    }
    return datos;
}
export function getDatosPresupuestoInterno(presupuesto) {
    let datos = {};
    switch (store.getters['user/rolId']) {
        case 1: /* Superadministrador */
        case 2: /* Direccion */
        case 3: /* Cuentas */
        case 6: /* Director Administrativo */
        case 7: /* Asist. Administracion */
        case 8: /* Calidad */
        case 9: /* Director Ejecutivo */
        case 12: /* Asistente de promociones */
        case 13: /* Asistente de cuentas */
        case 15: /* Coordinador/a de promociones */
        case 16: /* Ejecutivo comercial */
        case 17: /* Asistente comercial */
        case 19: /* Coordinador/a comercial */
        case 20: /* Gerente comercial */
        case 21: /* Responsable de Finanzas y Proveedores */
        case 22: /* Responsable de Facturacion e Impuestos */
        case 23: /* Asistente de Calidad */
            datos = {
                id: 0,
                prioridad: '',
                fechaEntrega: '',
                numero: 0,
                adicionalNumero: 0,
                presupuestoNumero: '',
                cliente: '',
                accion: '',
                clienteContacto: '',
                numeroOrdenCompra: '',
                descripcionOrdenCompra: '',
                feeAgencia: 0,
                feeAgenciaPremios: 0,
                discriminarFee: false,
                moneda: '',
                causaSocial: false,
                causaAmbiental: false
            }

            if (presupuesto.discriminarFeePremios) {
                datos.feeAgenciaPremios = 0;
            }
            break;
            
        default:
            datos = {
                id: 0,
                prioridad: '',
                fechaEntrega: '',
                numero: 0,
                adicionalNumero: 0,
                presupuestoNumero: '',
                cliente: '',
                accion: '',
            }
            break;
    }
    return datos;
}

export function getVistaPresupuestoInternoTotales(presupuesto) {
    let datos = []; 
    switch (store.getters['user/rolId']) {
        case 1: /* Superadmin */
        case 2: /* Dirección */
        case 3: /* Cuentas */
        case 4: /* Producción */
        case 6: /* Administración */
        case 7: /* Asistente de Administración */
        case 8: /* Calidad */
        case 9: /* Director Ejecutivo */
        case 12: /* Asistente de promociones */
        case 13: /* Asistente de cuentas */
        case 14: /* Asistente de produccion */
        case 15: /* Coordinador/a de promociones */
        case 16: /* Ejecutivo comercial */
        case 17: /* Asistente comercial */
        case 19: /* Coordinador/a comercial */
        case 20: /* Gerente comercial */
        case 21: /* Responsable de Finanzas y Proveedores */
        case 22: /* Responsable de Facturacion e Impuestos */
        case 23: /* Asistente de Calidad */
            if (parseFloat(presupuesto.importeFeePremios) != 0) {
                datos = [
                    { 'nombre': 'cotizacionTotal', 'campo': 'Subtotal', 'valor': presupuesto.cotizacionTotal, 'formato': 'moneda' },
                    { 'nombre': 'importeFee', 'campo': 'Fee de agencia', 'valor': presupuesto.importeFee, 'formato': 'moneda' },
                    { 'nombre': 'importeFeePremios', 'campo': 'Fee de rubros diferenciados', 'valor': presupuesto.importeFeePremios, 'formato': 'moneda' },
                    { 'nombre': 'importeNeto', 'campo': 'Total (Iva no incl.)', 'valor': presupuesto.importeNeto, 'formato': 'moneda' },
                ];
            } else {
                datos = [
                    { 'nombre': 'cotizacionTotal', 'campo': 'Subtotal', 'valor': presupuesto.cotizacionTotal, 'formato': 'moneda' },
                    { 'nombre': 'importeFee', 'campo': 'Fee de agencia', 'valor': presupuesto.importeFee, 'formato': 'moneda' },
                    { 'nombre': 'importeNeto', 'campo': 'Total (Iva no incl.)', 'valor': presupuesto.importeNeto, 'formato': 'moneda' },
                ];
            }
            break;
    
        default:
            datos = [];
            break;
    }
    return datos;
}
export function getVistaPresupuestoInternoRenglon(readOnly) {
    let vista = [];
    switch (store.getters['user/rolId']) {
        case 1:
        case 2:
        case 3: /* Cuentas */
        case 6:
        case 7:
        case 8: /* Calidad */
        case 9: /* Director Ejecutivo */
        case 12: /* Asistente de promociones */
        case 13: /* Asistente de cuentas */
        case 15: /* Coordinador/a de promociones */
        case 16: /* Ejecutivo comercial */
        case 17: /* Asistente comercial */
        case 19: /* Coordinador/a comercial */
        case 20: /* Gerente comercial */
        case 21: /* Responsable de Finanzas y Proveedores */
        case 22: /* Responsable de Facturacion e Impuestos */
        case 23: /* Asistente de Calidad */
            vista = [
                {
                    key: 'detailShowing',
                    label: '',
                    class: 'text-center'
                },
                {
                    key: 'rubroTrabajo',
                    label: 'Rubro',
                    sortable: true
                },
                {
                    key: 'titulo',
                    sortable: true
                },
                { key: 'cantidad', class: "text-right" },
                { 
                    key: 'costoInterno', 
                    label: 'Costo Interno',
                    class: "text-right" 
                },
                
                { key: 'pjeRentabilidad', class: "text-right", label: '% Rent.' },

                { 
                    key: 'cotizacionInterna', 
                    class: "text-right", 
                    label: 'Cotización Interna'
                },
                { 
                    key: 'cotizacion', 
                    class: "text-right", 
                    label: 'Cotización'
                },
                {
                    key: 'certificado',
                    label: '',
                    class: 'text-center'
                },

                { 
                    key: 'opciones',
                    label: '',
                    class: 'text-center'
                },
            ];
            break;

        case 4: /* Produccion */
        case 6:
        case 14: /* Asistente de produccion */
            vista = [
            {
                key: 'detailShowing',
                label: '',
                class: 'text-center'
            },
            {
                key: 'rubroTrabajo',
                label: 'Rubro',
                sortable: true
            },
            {
                key: 'titulo',
                sortable: true
            },
            { 
                key: 'cantidad', 
                class: "text-right" },
            { 
                key: 'costoReal', 
                label: 'Costo Real',
                // key: 'costoProveedor', 
                // label: 'Costo',
                class: "text-right" 
            },
            { 
                key: 'opciones',
                label: '',
                class: 'text-center'
            },
        ];
        break;
    }
    return vista;
}
export function getVistaPresupuestoInternoTotalesRenglon() {
    let vista = [];
    switch (store.getters['user/rolId']) {
        case 1:
        case 2:
        case 3:
        case 6:
        case 7:
        case 8: /* Calidad */
        case 9: /* Director Ejecutivo */
        case 12: /* Asistente de promociones */
        case 13: /* Asistente de cuentas */
        case 15: /* Coordinador/a de promociones */
        case 16: /* Ejecutivo comercial */
        case 17: /* Asistente comercial */
        case 19: /* Coordinador/a comercial */
        case 20: /* Gerente comercial */
        case 21: /* Responsable de Finanzas y Proveedores */
        case 22: /* Responsable de Facturacion e Impuestos */
        case 23: /* Asistente de Calidad */
            vista = [
                { key: 'blank_1'},
                { key: 'blank_2'},
                { key: 'blank_3'},
                { key: 'blank_4'},
                { key: 'costo', class: "text-right"},
                { key: 'blank_6'},
                { key: 'cotizacionInterna', class: "text-right"},
                { key: 'cotizacion', class: "text-right"},
                { key: 'blank_9'},
                { key: 'blank_10'},
            ];
            break;

        case 4: /* Produccion */
        case 5: /* Diseño */
        case 14: /* Asistente de produccion */
        case 24: /* Coordinador de Diseño */
            vista = [];
            break;
    }
    return vista;
}
export function getVistaDatosPresupuestoInternoRenglon(incluirAdicionales) {
    let vista = [];
    switch (store.getters['user/rolId']) {
        case 1: /* Superadmin */
        case 2: /* Direccion */
        case 3: /* Cuentas */
        case 8: /* Calidad */
        case 9: /* Director Ejecutivo */
        case 12: /* Asistente de promociones */
        case 13: /* Asistente de cuentas */
        case 15: /* Coordinador/a de promociones */
        case 16: /* Ejecutivo comercial */
        case 17: /* Asistente comercial */
        case 19: /* Coordinador/a comercial */
        case 20: /* Gerente comercial */
        case 23: /* Asistente de Calidad */
            vista = [];
            
            if (incluirAdicionales) {
                vista.push(
                    {
                        key: 'presupuestoAdicional',
                        label: 'Adicional',
                    });
            }

            vista.push(
                { 
                    key: 'tieneImagenes',
                    label: '',
                    class: 'text-center'
                },
                {
                    key: 'detailShowing',
                    label: '',
                    class: 'text-center'
                },
                {
                    key: 'rubroTrabajo',
                    label: 'Rubro',
                    sortable: true
                },
                {
                    key: 'titulo',
                    sortable: true
                },
                { 
                    key: 'cantidad', 
                    class: "text-right" 
                },
                { 
                    key: 'costoInterno', 
                    label: 'Costo Interno',
                    class: "text-right" 
                },
                { 
                    key: 'pjeRentabilidad', 
                    class: "text-right", 
                    label: '% Rent.' 
                },
                { 
                    key: 'costoReal', 
                    label: 'Costo Real',
                    class: "text-right" 
                },
                { 
                    key: 'pjeRentabilidadReal', 
                    class: "text-right", 
                    label: '% Rent. Real',
                },
                { 
                    key: 'cotizacionInterna', 
                    class: "text-right", 
                    label: 'Cotización Interna'
                },
                {
                    key: 'cotizacion', 
                    class: "text-right", 
                    label: 'Cotización'
                },
                {
                    key: 'alternativas', 
                    class: "text-right", 
                    label: ''
                },
                { 
                    key: 'opciones',
                    label: '',
                    class: 'text-center'
                },
            );
            break;

        case 6: /* Administración */
        case 7: /* Asistente de Administración */
        case 21: /* Responsable de Finanzas y Proveedores */
        case 22: /* Responsable de Facturacion e Impuestos */
            vista = [
                { 
                    key: 'tieneImagenes',
                    label: '',
                    class: 'text-center'
                },
                {
                    key: 'detailShowing',
                    label: '',
                    class: 'text-center'
                },
                {
                    key: 'rubroTrabajo',
                    label: 'Rubro',
                    sortable: true
                },
                {
                    key: 'titulo',
                    sortable: true
                },
                { 
                    key: 'cantidad', 
                    class: "text-right" 
                },
                { 
                    key: 'costoInterno', 
                    label: 'Costo Interno',
                    class: "text-right" 
                },
                { 
                    key: 'pjeRentabilidad', 
                    class: "text-right", 
                    label: '% Rent.' 
                },
                { 
                    key: 'cotizacionInterna', 
                    class: "text-right", 
                    label: 'Cotización Interna'
                },
                { 
                    key: 'cotizacion', 
                    class: "text-right", 
                    label: 'Cotización'
                },
                { 
                    key: 'opciones',
                    label: '',
                    class: 'text-center'
                },
            ];
            break;

        case 4: /* Producción */
        case 5: /* Diseño */
        case 10: /* Asistente de logistica */
        case 14: /* Asistente de producción */
        case 24: /* Coordinador de Diseño */
            vista = [
                { 
                    key: 'tieneImagenes',
                    label: '',
                    class: 'text-center'
                },
                {
                    key: 'detailShowing',
                    label: '',
                    class: 'text-center'
                },
                {
                    key: 'rubroTrabajo',
                    label: 'Rubro',
                    sortable: true
                },
                {
                    key: 'titulo',
                    sortable: true
                },
                { 
                    key: 'cantidad', 
                    class: "text-right" 
                },
                { 
                    key: 'costoInterno', 
                    label: 'Costo Interno',
                    class: "text-right" 
                },
                { 
                    key: 'costoReal', 
                    label: 'Costo Real',
                    class: "text-right" 
                },
                { 
                    key: 'opciones',
                    label: '',
                    class: 'text-center'
                },
            ];
            break;
    }
    return vista;
}
export function getDatosPresupuestoInternoRenglon() {
    let datos = {};
    switch (store.getters['user/rolId']) {
        case 1: /* Superadmin */
        case 2: /* Dirección */
        case 3: /* Cuentas */
        case 4: /* Producción */
        case 8: /* Calidad */
        case 9: /* Director Ejecutivo */
        case 12: /* Asistente de promociones */
        case 13: /* Asistente de cuentas */
        case 14: /* Asistente de producción */
        case 15: /* Coordinador/a de promociones */
        case 16: /* Ejecutivo comercial */
        case 17: /* Asistente comercial */
        case 19: /* Coordinador/a comercial */
        case 20: /* Gerente comercial */
        case 23: /* Asistente de Calidad */
            datos = {
                id: 0,
                presupuestoAdicional: 0,
                rubroTrabajo: '',
                categoriaServicioId: 0,
                categoriaServicio: '',
                titulo: '',
                descripcion: '',
                cantidad: 0,
                moneda: '',
                costoInterno: 0,
                pjeRentabilidad: 0,
                costoProveedor: 0,
                pjeRentabilidadProveedor: 0,
                costoReal: 0,
                pjeRentabilidadReal: 0,
                cotizacionInterna: 0,
                cotizacion: 0,
                importeDescuento: 0,
                importeFeeAgencia: 0,
                importeFinanciacion: 0,
                tieneImagenes: false,
                alternativas: []
            };                
            break;

        case 6: /* Administración */
        case 7: /* Asistente de Administración */
        case 21: /* Responsable de Finanzas y Proveedores */
        case 22: /* Responsable de Facturacion e Impuestos */
            datos = {
                rubroTrabajo: '',
                categoriaServicioId: 0,
                categoriaServicio: '',
                titulo: '',
                descripcion: '',
                cantidad: 0,
                moneda: '',
                costoInterno: 0,
                pjeRentabilidad: 0,
                cotizacionInterna: 0,
                cotizacion: 0,
                importeDescuento: 0,
                importeFeeAgencia: 0,
                importeFinanciacion: 0,
                tieneImagenes: false,
                alternativas: []
            };                
            break;
            
        case 10: /* Asistente de Logistica */
            datos = {
                rubroTrabajo: '',
                categoriaServicioId: 0,
                categoriaServicio: '',
                titulo: '',
                descripcion: '',
                cantidad: 0,
                moneda: '',
                costoInterno: 0,
                costoProveedor: 0,
                costoReal: 0,
                tieneImagenes: false,
                alternativas: []
            };                
            break;

        case 5: /* Diseño */
        case 24: /* Coordinador de Diseño */
            datos = {
                rubroTrabajo: '',
                titulo: '',
                descripcion: '',
                cantidad: 0,
                costoProveedor: 0,
                tieneImagenes: false
            };
            break;
    }
    return datos;
}
export function getDatosPresupuestosInternosList() {
    let datos = {};
    switch (store.getters['user/rolId']) {
        default:
            datos = {
                id: 0,
                presupuestoNumero: '',
                fechaRegistro: null,
                fechaUltimaEdicion: null,
                fechaConfirmacion: null,
                fechaCierre: null,
                cliente: '',
                accion: '',
                clienteContacto: '',
                moneda: '',
                causaSocial,
                causaAmbiental,
                cerrado,
                adicional
            };                
            break;
    }
    return datos;
}
export function getVistaPresupuestosInternosList(estado) {
    let vista = [];
    switch (store.getters['user/rolId']) {
        case 1:
        case 2:
        case 3: /* Cuentas */
        case 6:
        case 7:
        case 8: /* Calidad */
        case 9: /* Director Ejecutivo */
        case 12: /* Asistente de promociones */
        case 13: /* Asistente de cuentas */
        case 15: /* Coordinador/a de promociones */
        case 16: /* Ejecutivo comercial */
        case 17: /* Asistente comercial */
        case 19: /* Coordinador/a comercial */
        case 20: /* Gerente comercial */
        case 21: /* Responsable de Finanzas y Proveedores */
        case 22: /* Responsable de Facturacion e Impuestos */
        case 23: /* Asistente de Calidad */
            vista.push({
                key: 'presupuestoNumero',
                label: 'Nro.',
                sortable: true
            });
            if (estado != 'facturados' & estado != 'cerrados') {
                vista.push({ 
                    key: 'fechaUltimaEdicion',
                    label: 'Última Modif.',
                });
            }
            if (estado == 'confirmados') {
                vista.push({ 
                    key: 'fechaConfirmacion',
                    label: 'Confirmación', 
                });
            }
            if (estado == 'facturados') {
                vista.push({ 
                    key: 'fechaCierreEstimado',
                    label: 'Cierre Estimado', 
                });
            }
            if (estado == 'cerrados') {
                vista.push({ 
                    key: 'fechaCierre',
                    label: 'Cierre', 
                });
            }
            vista.push({ key: 'cliente' });
            vista.push({ key: 'accion' });
            vista.push({ 
                key: 'clienteContacto',
                label: 'Contacto' 
            });

            if (store.getters['user/rolId'] != 6 & store.getters['user/rolId'] != 7) {
                vista.push({ 
                    key: 'importeNetoPresupuestado',
                    label: 'Neto',
                    class: 'text-right' 
                });
            }

            if (estado == 'facturados' || estado == 'cerrados') {
                vista.push({ 
                    key: 'pjeCertificado',
                    class: 'text-right'
                });
                vista.push({ 
                    key: 'pjeFacturado',
                    class: 'text-right'
                });
                vista.push({ 
                    key: 'saldoFacturar',
                    class: 'text-right'
                });
            }
            vista.push({ 
                key: 'opciones',
                label: '',
                class: 'text-center'    
            });
            break;

        case 4: /* Produccion */
        case 5: /* Diseño */
        case 10: /* Asistente de logistica */
        case 14: /* Asistente de produccion */
        case 24: /* Coordinador de Diseño */
            vista = [
                {
                    key: 'presupuestoNumero',
                    label: 'Nro.',
                    sortable: true
                }];
                    
            vista.push({ 
                key: 'fechaUltimaEdicion',
                label: 'Última Modif.',
            });
            if (estado == 'confirmados') {
                vista.push({ 
                    key: 'fechaConfirmacion',
                    label: 'Confirmación', 
                });
            }
            if (estado == 'cerrados') {
                vista.push({ 
                    key: 'fechaCierre',
                    label: 'Cierre', 
                });
            }
            vista.push({ key: 'cliente' });
            vista.push({ key: 'accion' });
            vista.push({ 
                    key: 'opcionesProduccion',
                    label: '',
                    class: 'text-center'
            });
            break;
    }
    return vista;
}
export function getVistaPresupuestosInternosCanceladosList(estado) {
    let vista = [];
    switch (store.getters['user/rolId']) {
        case 1:
        case 2:
        case 3:
        case 6:
        case 7:
        case 8: /* Calidad */
        case 9: /* Director Ejecutivo */
        case 12: /* Asistente de promociones */
        case 13: /* Asistente de cuentas */
        case 15: /* Coordinador/a de promociones */
        case 16: /* Ejecutivo comercial */
        case 17: /* Asistente comercial */
        case 19: /* Coordinador/a comercial */
        case 20: /* Gerente comercial */
        case 21: /* Responsable de Finanzas y Proveedores */
        case 22: /* Responsable de Facturacion e Impuestos */
        case 23: /* Asistente de Calidad */
            vista.push({
                key: 'presupuestoNumero',
                label: 'Nro.',
                sortable: true
            });
            vista.push({ key: 'fechaRegistro' });

            vista.push({ 
                key: 'fechaCancelacion',
                label: 'Cancelación',
            });
            vista.push({ key: 'cliente' });
            vista.push({ key: 'accion' });
            vista.push({ 
                key: 'clienteContacto',
                label: 'Contacto' 
            });
            vista.push({ 
                key: 'usuarioCancelacion',
                label: 'Canceló' 
            });
            vista.push({ 
                    key: 'opciones',
                    label: '',
                    class: 'text-center'
            });
            break;

        case 4: /* Produccion */
        case 5: /* Diseño */
        case 14: /* Asistente de produccion */
        case 24: /* Coordinador de Diseño */
            vista = [
                {
                    key: 'presupuestoNumero',
                    label: 'Nro.',
                    sortable: true
                }];
            vista.push({ key: 'fechaRegistro' });
            vista.push({ 
                key: 'fechaUltimaEdicion',
                label: 'Modificado',
            });
            vista.push({ key: 'cliente' });
            vista.push({ key: 'accion' });
            break;
    }
    return vista;
}
export function getFiltroPresupuestosInternosListVisible(filtro) {
    let visible = false;
    switch (store.getters['user/rolId']) {
        case 1:
        case 2:
        case 6:
        case 7:
        case 8: /* Calidad */
        case 9: /* Director Ejecutivo */
        case 21: /* Responsable de Finanzas y Proveedores */
        case 22: /* Responsable de Facturacion e Impuestos */
        case 23: /* Asistente de Calidad */
            if (filtro == Filtro) {
                visible = true;
            }
            break;

        default:
            if (filtro == FiltroClientes) {
                visible = true;
            }
            break;
    }
    return visible;
}
